module.exports = __webpack_public_path__ + "static/media/OS&D.6680b0f8.png";